import { useIntl } from "react-intl";

import { CtaModal } from "ui/CtaModal";
import { BodyM } from "ui/Typography/Typography";

export function ShelfAlreadyAssignedModal({ onClose }: { onClose: () => void }) {
  const intl = useIntl();
  return (
    <CtaModal
      isOpen
      onClose={onClose}
      hideCloseButton
      onClickCta={onClose}
      title={intl.formatMessage({
        id: "components.shelf-changes.shelf-already-assigned-modal.title",
      })}
      ctaLabel={intl.formatMessage({ id: "generic.actions.close" })}
      body={
        <BodyM textAlign="center" color="grey.700">
          {intl.formatMessage({
            id: "components.shelf-changes.shelf-already-assigned-modal.description",
          })}
        </BodyM>
      }
    />
  );
}
